import { useFetchResponseWithUtils, useReselector } from '@/utils/sharedHooks'
import { WelcomeToPayroll } from './WelcomeToPayroll'
import { PayrollInterestOutroContent } from './interest-flow/PayrollInterestOutro'
import { getCurrentUser } from '@/selectors/user.selectors'
import { getMostRecentPayrollInterestSurvey } from './payrollInterestSurvey.actions'
import { Loader } from '@/ui'

export const PayrollUpsell = () => {
  // todo this data will be removed of user
  const user = useReselector(getCurrentUser)

  const latestPayrollSurvey = useFetchResponseWithUtils(
    getMostRecentPayrollInterestSurvey
  )

  const submittedGEPForm = Boolean(
    user?.gepRequestFormSubmittedAt ||
    latestPayrollSurvey.result?.gepRequestFormSubmittedAt
  )

  if (latestPayrollSurvey.loading) {
    return <Loader />
  }

  if (submittedGEPForm) {
    return (
      <div>
        <PayrollInterestOutroContent
          latestPayrollSurvey={latestPayrollSurvey.result}
        />
      </div>
    )
  }

  return <WelcomeToPayroll />
}
